import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiUserViewProfileTabBase } from '@fi-app/user/fi-user-view-dialog/fi-user-view-profile-tab-group/fi-user-view-profile-tab-base';
import { DataFieldSectionType } from '@fi-app/business-unit/data-field-section-type';

@Component({
    selector: 'fi-user-view-profile-tab-group',
    templateUrl: './fi-user-view-profile-tab-group.component.html',
    styleUrls: ['./fi-user-view-profile-tab-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-view-profile-tab-group' },
    standalone: false,
})
export class FiUserViewProfileTabGroupComponent extends FiUserViewProfileTabBase {
    DataFieldSectionType = DataFieldSectionType;

    getDataFieldsBySectionType(sectionType: DataFieldSectionType) {
        return this.dataFieldHelperService.getDataFieldsBySectionType(this.userDataFields, sectionType);
    }

    isOtherTabShown(): boolean {
        return this.dataFieldHelperService.isCustomDataFieldValueDefined(this.userDataFields);
    }
}
